// extracted by mini-css-extract-plugin
export default {"listElement":"List_listElement__EWvH9","header":"List_header__TAVFw","chevron":"List_chevron__p3Yyf","bodyIsOpen":"List_bodyIsOpen__AtA7L"};